import { EventDiscountCheck, UsedEventDiscount } from "../models/Event";
import { Client } from "../types/internal";

export const createEventDiscount = (client: Client) => ({
  check: (token: string) => {
    return client.get<EventDiscountCheck>(["event-discounts", token, "check"]);
  },
  use: (token: string) => {
    return client.post<UsedEventDiscount>(["event-discounts", token, "use"]);
  },
});
